import React, {useState} from 'react';
import LoadingButton from "../../base/components/loadingButton";
import {useParams} from "react-router-dom";
import axios from "../../../helpers/axios";

const PaitedServButton = () => {
  const [loading,setLoading] = useState(false)
  const {id} = useParams();

  const painted = () =>{
    setLoading(true)
    axios.post('/api/racoon/revise/group/paintServices/'+id)
      .then(()=>window.alert("Услуги покрашены"))
      .finally(()=>setLoading(false))
  }

  return (
    <LoadingButton title={'Покрасить Услуги'}
                   loading={loading}
                   type={'button'}
                   onClick={painted}
                   size={'sm'}
                   variant={'outline-secondary'}/>
  );
};

export default PaitedServButton;
